// src/pages/AdministradoresPage.js

import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../context/DataContext";
import Select from "react-select";
import { FaChalkboardTeacher } from "react-icons/fa";
import "../styles/pages.css";
import { asignarColegioProfesor, actualizarUsuarioEva } from "../services/api";
import { AsyncPaginate } from 'react-select-async-paginate';

const CardAdmin = ({ icon, title, children }) => (
  <div className="card-admin">
    <div className="card-admin-header">
      {icon}
      <span>{title}</span>
    </div>
    <div className="card-admin-body">
      {children}
    </div>
  </div>
);
const AdministradoresPage = () => {
  const {loadingData, errorData, loadData} = useContext(DataContext);
  const [profesorSeleccionado, setProfesorSeleccionado] = useState("");
  const [colegios, setColegios] = useState([]);
  const [colegioSeleccionado, setColegioSeleccionado] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [errorAsignacion, setErrorAsignacion] = useState("");
  const [profesores, setProfesores] = useState([]);
  const [colegioAsignar, setColegioAsignar] = useState(null);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [password, setPassword] = useState("");
  const [mensajeAsignacionRol, setMensajeAsignacionRol] = useState("");
  const [errorAsignacionRol, setErrorAsignacionRol] = useState(""); 
  const [rolEstadistica, setRolEstadistica] = useState("");
  const [loadingAsignacion, setLoadingAsignacion] = useState(false);
  const [opcionesRoles, setOpcionesRoles] = useState([]);

  const opcionesColegios = colegios.map((col) => ({
    value: col.id,
    label: col.name,
  }));

  const opcionesProfesores = profesores
  .filter((p) => p.rolEstadistica === "profesor")
  .map((p) => ({
    value: p.username,
    label: p.username + " - " + p.firstname + " " + p.lastname,
    data: p
  }));

  useEffect(() => {
    fetch("https://apiatschool.roboticminds.ec/data/colegios")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setColegios(data);
        } else {
          console.error("La respuesta no es un array:", data);
        }
      })
      .catch((err) => console.error("Error cargando colegios:", err));
  }, []);

  useEffect(() => {
    fetch("https://apiatschool.roboticminds.ec/data/profesores")
      .then((res) => res.json())
      .then((data) => setProfesores(data))
      .catch((err) => console.error("Error cargando profesores:", err));
  }, []);

  useEffect(() => {
  fetch("https://apiatschool.roboticminds.ec/data/roles-estadistica")
    .then((res) => res.json())
    .then((data) => {
      const opciones = data.map((rol) => ({
        value: rol,
        label: rol.charAt(0).toUpperCase() + rol.slice(1),
      }));
      setOpcionesRoles(opciones);
    })
    .catch((err) => console.error("Error cargando roles:", err));
}, []);
  
  if (loadingData) {
    return (
      <div className="loading-container">
        <h2>Cargando datos...</h2>
        <div className="loader"></div>
      </div>
    );
  }

  if (errorData) {
    return (
      <div className="loading-container">
        <h2 className="error-text">Error al cargar datos</h2>
        <p>{errorData.message}</p>
        <button onClick={() => loadData(colegioSeleccionado)} className="btn-admin" style={{ marginTop: 10 }}>
          Reintentar
        </button>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="admin-row">
        <CardAdmin icon={<FaChalkboardTeacher />} title="Filtro de colegio">
          <div className="page-card-body"></div>
          <div className="mb-4 d-flex justify-content-center">
            <div className="select-responsive">
              <Select
                options={opcionesColegios}
                value={opcionesColegios.find((o) => o.value === colegioSeleccionado) || null}
                onChange={(opcion) => setColegioSeleccionado(opcion.value)}
                placeholder="Seleccionar colegio"
                isSearchable
                noOptionsMessage={() => "No hay colegios disponibles"}
              />
            </div>
          </div>

          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <button
              className="btn-admin"
              onClick={() => loadData(colegioSeleccionado)}
              disabled={!colegioSeleccionado}
            >
              Actualizar datos
            </button>
          </div>
        </CardAdmin>
        
        <CardAdmin icon={<FaChalkboardTeacher />} title="Asignar colegio a profesor">
          <div className="page-card-body"></div>
            <div className="mb-3 d-flex justify-content-center"  style={{ flexDirection: "column", alignItems: "center" }}>
              <div className="select-responsive">
                <Select
                  options={opcionesProfesores}
                  value={opcionesProfesores.find((o) => o.value === profesorSeleccionado?.username) || null}
                  onChange={(opcion) => setProfesorSeleccionado(opcion.data)}
                  placeholder="Seleccionar Profesor"
                  isSearchable
                  noOptionsMessage={() => "No hay profesores disponibles"}
                />
              </div>
              <div className="select-responsive">
                <Select
                  options={opcionesColegios}
                  value={opcionesColegios.find((o) => o.value === colegioAsignar) || null}
                  onChange={(opcion) => setColegioAsignar(opcion.value)}
                  placeholder="Seleccionar colegio para asignar"
                  isSearchable
                  noOptionsMessage={() => "No hay colegios disponibles"}
                />
              </div>
            </div>

            <div style={{ textAlign: "center", marginBottom: 20 }}>
              <button
                className="btn-admin"
                disabled={!profesorSeleccionado || !colegioAsignar}
                onClick={async () => {
                  setMensaje("");
                  setErrorAsignacion("");
                  try {
                      await asignarColegioProfesor({
                      username: profesorSeleccionado.username,
                      categoryId: parseInt(colegioAsignar),
                    });
                    setMensaje("Colegio asignado correctamente.");
                  } catch (error) {
                    console.error(error);
                    setErrorAsignacion("Error al asignar colegio.");
                  }
                }}
              >
                Asignar colegio
              </button>
              {mensaje && <p style={{ color: "green", marginTop: 10 }}>{mensaje}</p>}
              {errorAsignacion && <p style={{ color: "red", marginTop: 10 }}>{errorAsignacion}</p>}
            </div>
        </CardAdmin>

        <CardAdmin icon={<FaChalkboardTeacher />} title="Asignar contraseña y rol">
          <div className="page-card-body d-flex flex-column align-items-center">
            <div className="select-responsive">
              <AsyncPaginate
                value={
                  usuarioSeleccionado
                    ? {
                        value: usuarioSeleccionado.username,
                        label: `${usuarioSeleccionado.username} - ${usuarioSeleccionado.firstname} ${usuarioSeleccionado.lastname}`,
                      }
                    : null
                }
                loadOptions={async (inputValue, loadedOptions, { page = 1 }) => {
                  try {
                    const limit = 10;
                    const res = await fetch(`https://apiatschool.roboticminds.ec/data/usuarios?page=${page}&query=${inputValue}`);
                    const data = await res.json();

                    const options = data.map((u) => ({
                      value: u.username,
                      label: `${u.username} - ${u.firstname} ${u.lastname}`,
                      data: u,
                    }));

                    return {
                      options,
                      hasMore: data.length === limit,
                      additional: { page: page + 1 },
                    };
                  } catch (error) {
                    console.error("Error al cargar usuarios sin rol:", error);
                    return {
                      options: [],
                      hasMore: false,
                    };
                  }
                }}
                onChange={(opcion) => setUsuarioSeleccionado(opcion.data)}
                additional={{ page: 1 }}
                placeholder="Seleccionar usuario sin rol"
                isSearchable
                styles={{ container: (base) => ({ ...base, width:  "100%" }) }}
              />
            </div>

            <div className="input-responsive">
              <input
                type="password"
                placeholder="Nueva contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ marginBottom: 15, width:  "100%", padding: 8 }}
              />
            </div>

            <div className="select-responsive">
              <Select
                options={opcionesRoles}
                value={opcionesRoles.find((o) => o.value === rolEstadistica) || null}
                onChange={(opcion) => setRolEstadistica(opcion.value)}
                placeholder="Seleccionar rol"
                isSearchable
                styles={{ container: (base) => ({ ...base, width:  "100%",  }) }}
              />
            </div>
          </div>

          <div style={{ textAlign: "center"}}>
            <button
              className="btn-admin"
              disabled={!usuarioSeleccionado || !rolEstadistica || loadingAsignacion}
              onClick={async () => {
                setMensajeAsignacionRol("");
                setErrorAsignacionRol("");
                setLoadingAsignacion(true);

                try {
                  await actualizarUsuarioEva({
                    username: usuarioSeleccionado.username,
                    rolEstadistica,
                    categoryId: usuarioSeleccionado.categoryId
                  });

                  setMensajeAsignacionRol("Rol asignado correctamente.");
                  setRolEstadistica("");

                } catch (err) {
                  console.error(err);
                  setErrorAsignacionRol("Error al asignar rol.");
                
                } finally {
                  setLoadingAsignacion(false);
                }  
              }}
            >
              {loadingAsignacion ? "Guardando..." : "Asignar rol"}
            </button>
          </div>
              
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <button
              className="btn-admin"
              disabled={!usuarioSeleccionado || !password || loadingAsignacion}
              onClick={async () => {
                setMensajeAsignacionRol("");
                setErrorAsignacionRol("");
                setLoadingAsignacion(true);

                try {
                  await actualizarUsuarioEva({
                    username: usuarioSeleccionado.username,
                    password,
                    categoryId: usuarioSeleccionado.categoryId,
                  });
                  setMensajeAsignacionRol("Contraseña actualizada correctamente.");
                  setPassword("");

                } catch (err) {
                  console.error(err);
                  setErrorAsignacionRol("Error al actualizar contraseña.");
                } finally {
                  setLoadingAsignacion(false);
                }
              }}
            >
              {loadingAsignacion ? "Guardando..." : "Actualizar contraseña"}
            </button>
            {mensajeAsignacionRol && <p style={{ color: "green", marginTop: 10 }}>{mensajeAsignacionRol}</p>}
            {errorAsignacionRol && <p style={{ color: "red", marginTop: 10 }}>{errorAsignacionRol}</p>}
          </div>

        </CardAdmin>
        
      </div>
    </div>
  );
};

export default AdministradoresPage;
